import ReactPaginate from "react-paginate";

// quick and dirty fix WCAG issues mit ReactPaginate
// use own Pagination in the future

function classNameIfDefined(className, orClassName = '') {
  return className !== undefined && className !== null
    ? className
    : orClassName;
}

// Override render
export default class ReactPaginateWCAG extends ReactPaginate {
  render() {
    const { renderOnZeroPageCount } = this.props;
    if (this.props.pageCount === 0 && renderOnZeroPageCount !== undefined) {
      return renderOnZeroPageCount
        ? renderOnZeroPageCount(this.props)
        : renderOnZeroPageCount;
    }
    const {
      disabledClassName,
      disabledLinkClassName,
      pageCount,
      className,
      containerClassName,
      previousLabel,
      previousClassName,
      previousLinkClassName,
      previousAriaLabel,
      prevRel,
      nextLabel,
      nextClassName,
      nextLinkClassName,
      nextAriaLabel,
      nextRel,
      ariaTitle,
    } = this.props;

    const { selected } = this.state;

    const isPreviousDisabled = selected === 0;
    const isNextDisabled = selected === pageCount - 1;

    const previousClasses = `${classNameIfDefined(previousClassName)}${isPreviousDisabled ? ` ${classNameIfDefined(disabledClassName)}` : ''
      }`;
    const nextClasses = `${classNameIfDefined(nextClassName)}${isNextDisabled ? ` ${classNameIfDefined(disabledClassName)}` : ''
      }`;

    const previousLinkClasses = `${classNameIfDefined(previousLinkClassName)}${isPreviousDisabled ? ` ${classNameIfDefined(disabledLinkClassName)}` : ''
      }`;
    const nextLinkClasses = `${classNameIfDefined(nextLinkClassName)}${isNextDisabled ? ` ${classNameIfDefined(disabledLinkClassName)}` : ''
      }`;

    const previousAriaDisabled = isPreviousDisabled ? 'true' : 'false';
    const nextAriaDisabled = isNextDisabled ? 'true' : 'false';

    return (
      <nav title={ariaTitle || "Pagination"} aria-label={ariaTitle || "Pagination"} className="d-flex align-items-center">
        <ul
          className={className || containerClassName}
          aria-label="Liste der Seiten"
        >
          <li className={previousClasses}>
            <a
              className={previousLinkClasses}
              href={this.getElementHref(selected - 1)}
              tabIndex={isPreviousDisabled ? '-1' : '0'}
              role="button"
              onKeyPress={this.handlePreviousPage}
              aria-disabled={previousAriaDisabled}
              aria-label={previousAriaLabel}
              rel={prevRel}
              {...this.getEventListener(this.handlePreviousPage)}
            >
              {previousLabel}
            </a>
          </li>

          {this.pagination()}

          <li className={nextClasses}>
            <a
              className={nextLinkClasses}
              href={this.getElementHref(selected + 1)}
              tabIndex={isNextDisabled ? '-1' : '0'}
              role="button"
              onKeyPress={this.handleNextPage}
              aria-disabled={nextAriaDisabled}
              aria-label={nextAriaLabel}
              rel={nextRel}
              {...this.getEventListener(this.handleNextPage)}
            >
              {nextLabel}
            </a>
          </li>
        </ul>
      </nav>
    );
  }
}

